import ApiService from '@/common/api.service'

export default {
  save (memberFamily) {
    return new Promise((resolve, reject) => {
      ApiService.post('/member-family/save', memberFamily).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  delete (memberFamilyIds) {
    return new Promise((resolve, reject) => {
      ApiService.post('/member-family/delete', memberFamilyIds).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getMemberFamilyAndChronicle () {
    return new Promise((resolve, reject) => {
      ApiService.query('/member-family/chronicle').then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getMemberFamilyAndChronicleByMemberId (memberId) {
    return new Promise((resolve, reject) => {
      ApiService.query(`/member-family/chronicle/${memberId}`).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  updateSortMember (sortMember) {
    return new Promise((resolve, reject) => {
      ApiService.post('/member-family/sort', sortMember).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
